import { create_element, queue_tasks } from 'js/utils';

export default function product_options_init(){ 
    
    queue_tasks([
        //qty_option,
        qty_option_counter,
        get_all_variation,
        custom_variation_option, 
    ]);
} 

const price_container = document.querySelector('.custom-price .price'); 
const old_price = price_container.innerHTML; 
 
function qty_option_counter(){
    let display_qty = document.querySelector('.qty_ctr .qty_input'); 
    let qty_box = document.querySelector('.elementor-add-to-cart .input-text.qty');
    let qty_min = parseInt(display_qty.min||1);
    let qty_max = display_qty.max || 9999;
    if( qty_max == -1 ) qty_max = 9999;

    display_qty.addEventListener('change', (event)=>{ 
        qty_box.value = event.target.value;     
    });

    const minus = document.querySelector('.qty_option .qty_ctr .minus');
    const plus = document.querySelector('.qty_option .qty_ctr .plus');  

    minus.addEventListener('click', ()=>{
        display_qty.value--;
        if( display_qty.value < qty_min ) {
            display_qty.value = qty_min;
        }
        qty_box.value = display_qty.value;     
    });

    plus.addEventListener('click', ()=>{ 
        display_qty.value++;
        if( display_qty.value > qty_max ) { 
            display_qty.value = qty_max;
        }
        qty_box.value = display_qty.value;    
    });
}

function qty_option(){
    const container = document.querySelector('.qty_option');

    const qty_box = document.querySelector('.elementor-add-to-cart .input-text.qty');
    let i = 1;
    container.querySelectorAll('.item').forEach(item => {
        if(i == 1){
            item.classList.add('selected'); 
        }

        item.addEventListener('click', ()=>{

            container.querySelectorAll('.item').forEach(el => {
                el.classList.remove('selected');          
            });

            item.classList.add('selected'); 

            qty_box.value = item.dataset.value;

        });
        i++;
    });
}

function get_all_variation(){
    const variation_table = document.querySelectorAll('.variations_form .variations select'); 

    const container = document.querySelector('.varations_option');

    if(variation_table.length == 0 ) return; 

    variation_table.forEach(item => {
        let item_name = item.name;
        let item_attribute_name = item.dataset.attribute_name;

        let label_name = item_name.split('attribute_')[1];
        let label_text = label_name.replace('pa_','');

        const sec_option = document.createElement('div');
        sec_option.className = `custom_variable sec_options ${item_name}`;
        sec_option.dataset.attribute_name = item_attribute_name;

        const select_options = document.createElement('div');
        select_options.className = 'items'; 
        
        create_element({text: `Select ${label_text}*`, class_name: `l `, render: sec_option});

        let optionNames = [...item.options].map(o => o.text);
        let optionValues = [...item.options].map(o => o.value);

        for(let i = 0 ; i < optionValues.length ; i++ ){ 
            let el = create_element({text: optionNames[i], class_name: 'item', render: select_options});
            el.dataset.value = optionValues[i];
            el.dataset.name = optionNames[i];
        }
        sec_option.append(select_options);
        container.append(sec_option);

    });

}


function custom_variation_option(){
    
    const items = document.querySelectorAll('.sec_options .item');
     
    items.forEach(item => {

        const container = item.closest('.sec_options'); 
        const attribute_name = container.dataset.attribute_name;
        const variation_box = document.querySelector(`[name="${attribute_name}"]`);

        item.addEventListener('click', ()=>{
            const selected = item.dataset.value;
 
            container.querySelectorAll('.item').forEach(el => {
                el.classList.remove('selected');          
            });

            item.classList.add('selected');  
            if(!selected ) {
                variation_box.options[0].selected = true;
                variation_box.dispatchEvent(new Event('change', { 'bubbles': true }));
                price_change(0); 
                return; 
            };
            variation_box.querySelector(`[value='${selected}']`).selected = true;  
            variation_box.dispatchEvent(new Event('change', { 'bubbles': true }));
            price_change(1);
        })
    });

}

function price_change (option){
    if(!option) return price_container.innerHTML = old_price;

    const new_price_container = document.querySelector('.elementor-add-to-cart .woocommerce-variation-price .price');
    if(!new_price_container) return price_container.innerHTML = old_price;
    
    price_container.innerHTML = new_price_container.innerHTML;
    
}
 